import { render, staticRenderFns } from "./accepted-table.vue?vue&type=template&id=538ab7c0&scoped=true&"
import script from "./accepted-table.vue?vue&type=script&lang=js&"
export * from "./accepted-table.vue?vue&type=script&lang=js&"
import style0 from "./accepted-table.vue?vue&type=style&index=0&id=538ab7c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538ab7c0",
  null
  
)

export default component.exports